module.exports = __webpack_public_path__ + "img/hero_circle.b294932a.gif";